<template>
  <v-content>
    <v-container>
      <v-layout justify-center class="mt-5">
        <v-flex xs12 sm8 md5>
          <v-form ref="form" @submit.prevent="submit" lazy-validation>
            <h2 class="headline pb-2">Forgot Password</h2>
            <p class="body-1 pb-2">
              Enter the email address associated with your account. If an
              account exists, we'll send a password reset link.
            </p>

            <v-text-field
              v-model="email"
              label="Email Address"
              solo
              flat
              type="email"
              :rules="[required, validEmail]"
              :disabled="loading || sent"
            />

            <v-alert v-if="errorMessage" type="error" class="mb-3">
              {{ errorMessage }}
            </v-alert>
            <v-alert v-if="sent" type="success" class="mb-3">
              If an account with that email exists, a reset link has been sent.
              Check your inbox.
            </v-alert>

            <v-layout align-center>
              <v-btn
                v-if="!sent"
                depressed
                color="secondary"
                class="white--text ma-0"
                type="submit"
                :loading="loading"
              >
                Send Reset Link
              </v-btn>
              <span class="ml-3 body-2">
                <router-link :to="{ name: 'Provider-Login' }"
                  >Back to login</router-link
                >
              </span>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";

const baseUrl =
  (window.location.hostname === "localhost"
    ? "http://" + window.location.hostname + ":3000"
    : window.location.origin) + "/api";

export default {
  name: "ProviderForgotPassword",
  data() {
    return {
      email: "",
      loading: false,
      sent: false,
      errorMessage: ""
    };
  },
  methods: {
    required: v => !!v || "This field is required.",
    validEmail: v =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Enter a valid email address.",

    async submit() {
      if (!this.$refs.form.validate()) return;
      this.errorMessage = "";
      this.loading = true;
      try {
        await axios.post(`${baseUrl}/providers/forgot-password`, {
          email: this.email
        });
        this.sent = true;
      } catch {
        // Show same success message to prevent email enumeration
        this.sent = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
form {
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: 0.5em;
}
</style>
